module.exports = __webpack_public_path__ + "img/play.3d5705c3.png";